<template>
  <div
    class="camadas-painel"
    :class="{ 'camadas-painel--recolhido': recolhido }"
  >
    <div class="camadas-painel__cabecalho" @click="recolhido = !recolhido">
      <md-icon>layers</md-icon>
      <span class="camadas-painel__titulo">Camadas ({{ totalTopo }})</span>

      <md-button
        v-if="podeEditar"
        class="md-icon-button md-dense camadas-painel__add"
        :disabled="carregando"
        @click.stop="acionarInputAdicionar"
      >
        <md-icon>library_add</md-icon>
        <md-tooltip md-direction="top">Adicionar KML ou INP</md-tooltip>
      </md-button>

      <md-icon class="camadas-painel__chevron">
        {{ recolhido ? 'expand_more' : 'expand_less' }}
      </md-icon>
    </div>

    <div v-show="!recolhido" class="camadas-painel__conteudo">
      <div v-if="carregando" class="camadas-painel__carregando">
        <md-progress-spinner
          md-mode="indeterminate"
          :md-diameter="20"
          :md-stroke="2"
        />
        <span>Carregando…</span>
      </div>

      <div class="camadas-painel__corpo">
        <ul class="camadas-lista">
          <li class="camadas-item camadas-item--grupo">
            <md-button
              class="md-icon-button md-dense camadas-item__chevron"
              @click="equipamentosColapsado = !equipamentosColapsado"
            >
              <md-icon>
                {{ equipamentosColapsado ? 'chevron_right' : 'expand_more' }}
              </md-icon>
            </md-button>

            <md-button
              class="md-icon-button md-dense camadas-item__olho"
              @click="$emit('toggle-equipamentos')"
            >
              <md-icon>
                {{ equipamentosVisiveis ? 'visibility' : 'visibility_off' }}
              </md-icon>
              <md-tooltip md-direction="top">
                {{ equipamentosVisiveis ? 'Ocultar' : 'Mostrar' }}
              </md-tooltip>
            </md-button>

            <img
              v-if="legendaHub"
              :src="legendaHub"
              class="camadas-item__legenda-icone"
              :class="{
                'camadas-item__legenda-icone--oculto': !equipamentosVisiveis,
              }"
              alt=""
            />
            <span v-else class="camadas-item__cor-espaco"></span>

            <div class="camadas-item__info">
              <span class="camadas-item__nome">Equipamentos</span>
            </div>
          </li>

          <li
            v-show="!equipamentosColapsado"
            class="camadas-item camadas-item--grupo camadas-item--filha"
          >
            <md-button
              class="md-icon-button md-dense camadas-item__chevron"
              @click="sensoresColapsado = !sensoresColapsado"
            >
              <md-icon>
                {{ sensoresColapsado ? 'chevron_right' : 'expand_more' }}
              </md-icon>
            </md-button>

            <md-button
              class="md-icon-button md-dense camadas-item__olho"
              @click="$emit('toggle-sensores')"
            >
              <md-icon>
                {{ algumSensorVisivel ? 'visibility' : 'visibility_off' }}
              </md-icon>
              <md-tooltip md-direction="top">
                {{ algumSensorVisivel ? 'Ocultar' : 'Mostrar' }}
              </md-tooltip>
            </md-button>

            <span class="camadas-item__cor-espaco"></span>

            <div class="camadas-item__info">
              <span class="camadas-item__nome">Sensores</span>
            </div>
          </li>

          <li
            v-for="tipo in tiposIconeMapa"
            v-show="!equipamentosColapsado && !sensoresColapsado"
            :key="'sensor-' + tipo.id"
            class="camadas-item camadas-item--neta"
          >
            <md-button
              class="md-icon-button md-dense camadas-item__olho"
              @click="$emit('toggle-sensor-icone', tipo.id)"
            >
              <md-icon>
                {{
                  iconeSensorVisivel(tipo.id) ? 'visibility' : 'visibility_off'
                }}
              </md-icon>
              <md-tooltip md-direction="top">
                {{ iconeSensorVisivel(tipo.id) ? 'Ocultar' : 'Mostrar' }}
              </md-tooltip>
            </md-button>

            <img
              v-if="legendasSensor[tipo.id]"
              :src="legendasSensor[tipo.id]"
              class="camadas-item__legenda-icone"
              :class="{
                'camadas-item__legenda-icone--oculto': !iconeSensorVisivel(
                  tipo.id
                ),
              }"
              alt=""
            />
            <span v-else class="camadas-item__cor-espaco"></span>

            <div class="camadas-item__info">
              <span class="camadas-item__nome" :title="tipo.nome">
                {{ tipo.nome }}
              </span>
            </div>
          </li>
        </ul>

        <p
          v-if="!carregando && camadas.length === 0"
          class="camadas-painel__vazio"
        >
          Nenhuma camada. Adicione um arquivo KML ou INP.
        </p>

        <ul v-if="camadas.length > 0" class="camadas-lista">
          <li
            v-for="item in itensArvore"
            :key="item.camada.id"
            class="camadas-item"
            :class="{
              'camadas-item--grupo': item.camada.tipo === 'grupo',
              'camadas-item--filha': item.nivel === 1,
            }"
          >
            <!-- Chevron: só o grupo expande/colapsa; folhas de topo reservam o
               espaço para alinhar o olho na mesma coluna. -->
            <md-button
              v-if="item.camada.tipo === 'grupo'"
              class="md-icon-button md-dense camadas-item__chevron"
              @click="alternarGrupo(item.camada.id)"
            >
              <md-icon>
                {{
                  colapsados[item.camada.id] ? 'chevron_right' : 'expand_more'
                }}
              </md-icon>
            </md-button>
            <span
              v-else-if="item.nivel === 0"
              class="camadas-item__chevron-espaco"
            ></span>

            <md-button
              class="md-icon-button md-dense camadas-item__olho"
              @click="$emit('toggle', item.camada.id)"
            >
              <md-icon>
                {{ olhoVisivel(item.camada) ? 'visibility' : 'visibility_off' }}
              </md-icon>
              <md-tooltip md-direction="top">
                {{ olhoVisivel(item.camada) ? 'Ocultar' : 'Mostrar' }}
              </md-tooltip>
            </md-button>

            <!-- Coluna de cor/legenda:
               • válvula/reservatório → ícone como legenda (destaca mais que a
                 cor). Nenhum dos dois tem cor única: a válvula é colorida pela
                 escala de diâmetro (como tubulações) e o reservatório não tem
                 cor.
               • KML / seções INP comuns → swatch de cor.
               • junções / tubulações / válvulas → círculo / traço / ícone
                 (geometria do mapa; a cor vem da escala Cota/Diâmetro).
               • grupo → espaço reservado (alinhamento). -->
            <img
              v-if="usaIcone(item.camada)"
              :src="iconeUrl(item.camada)"
              class="camadas-item__legenda-icone"
              :class="{
                'camadas-item__legenda-icone--oculto': !item.camada.visivel,
                'camadas-item__legenda-icone--clicavel': temCor(item.camada),
              }"
              :title="
                temCor(item.camada) ? 'Clique para mudar a cor da linha' : ''
              "
              alt=""
              @click="temCor(item.camada) && abrirSeletorCor(item.camada)"
            />
            <img
              v-else-if="iconeGeometriaUrl(item.camada)"
              :src="iconeGeometriaUrl(item.camada)"
              class="camadas-item__legenda-icone"
              :class="{
                'camadas-item__legenda-icone--oculto': !item.camada.visivel,
              }"
              alt=""
            />
            <input
              v-else-if="mostrarSwatch(item.camada)"
              type="color"
              class="camadas-item__cor"
              :class="{ 'camadas-item__cor--oculto': !item.camada.visivel }"
              :data-cor-id="item.camada.id"
              :value="item.camada.cor"
              title="Clique para mudar a cor da camada"
              @change="
                $emit('alterar-cor', {
                  id: item.camada.id,
                  cor: $event.target.value,
                })
              "
            />
            <span v-else class="camadas-item__cor-espaco"></span>

            <!-- Input de cor escondido da válvula (a legenda é ícone, mas a aresta
               é colorível): o clique no ícone / no kebab dispara este seletor. -->
            <input
              v-if="usaIcone(item.camada) && temCor(item.camada)"
              type="color"
              class="camadas-item__cor-gatilho"
              :data-cor-id="item.camada.id"
              :value="item.camada.cor"
              @change="
                $emit('alterar-cor', {
                  id: item.camada.id,
                  cor: $event.target.value,
                })
              "
            />

            <div class="camadas-item__info">
              <span class="camadas-item__nome" :title="item.camada.nome">
                {{ item.camada.nome }}
              </span>
              <span
                v-if="item.camada.erro"
                class="camadas-item__erro"
                :title="item.camada.erro"
              >
                {{ rotuloErro(item.camada) }}
              </span>
            </div>

            <!-- Flag de ajuste local: aparece só quando a linha difere do padrão.
               Faz papel duplo — indica que há override E volta ao padrão em um
               clique (todos os papéis; cobre grupo, seção INP e KML). -->
            <md-button
              v-if="temOverride(item.camada)"
              class="md-icon-button md-dense camadas-item__restaurar"
              @click="$emit('restaurar', item.camada.id)"
            >
              <md-icon>settings_backup_restore</md-icon>
              <md-tooltip md-direction="top">Voltar ao padrão</md-tooltip>
            </md-button>

            <!-- Kebab em toda linha que tenha ao menos uma ação para o usuário:
               "Alterar cor" vale para todos (inclui cada seção INP);
               renomear/editar/substituir/remover e "Definir como padrão para
               todos" exigem edição (o backend reforça). -->
            <md-menu
              v-if="mostrarKebab(item.camada)"
              class="camadas-item__acoes"
              md-size="small"
              md-direction="bottom-end"
              md-align-trigger
            >
              <md-button
                class="md-icon-button md-dense"
                md-menu-trigger
                :disabled="carregando"
              >
                <md-icon>more_vert</md-icon>
              </md-button>

              <md-menu-content class="camadas-menu">
                <md-menu-item
                  v-if="podeEditarArquivo(item.camada)"
                  @click="abrirRenomear(item.camada)"
                >
                  <md-icon>edit</md-icon>
                  <span class="md-list-item-text">Renomear</span>
                </md-menu-item>
                <md-menu-item
                  v-if="temCor(item.camada)"
                  @click="abrirSeletorCor(item.camada)"
                >
                  <md-icon>palette</md-icon>
                  <span class="md-list-item-text">Alterar cor</span>
                </md-menu-item>
                <md-menu-item
                  v-if="podeEditarArquivo(item.camada)"
                  @click="abrirEditorTexto(item.camada)"
                >
                  <md-icon>code</md-icon>
                  <span class="md-list-item-text">Editar texto</span>
                </md-menu-item>
                <md-menu-item
                  v-if="podeEditarArquivo(item.camada)"
                  @click="acionarInputSubstituir(item.camada)"
                >
                  <md-icon>upload_file</md-icon>
                  <span class="md-list-item-text">Substituir arquivo</span>
                </md-menu-item>
                <md-menu-item
                  v-if="podeSalvarPadrao(item.camada)"
                  @click="$emit('salvar-padrao', item.camada.id)"
                >
                  <md-icon>save</md-icon>
                  <span class="md-list-item-text">
                    Definir como padrão para todos
                  </span>
                </md-menu-item>
                <md-menu-item
                  v-if="podeEditarArquivo(item.camada)"
                  @click="camadaParaRemover = item.camada"
                >
                  <md-icon>delete</md-icon>
                  <span class="md-list-item-text">Remover</span>
                </md-menu-item>
              </md-menu-content>
            </md-menu>
          </li>
        </ul>
      </div>
    </div>

    <!-- Inputs de arquivo escondidos -->
    <input
      ref="inputAdicionar"
      type="file"
      accept=".kml,.inp"
      multiple
      class="camadas-input-oculto"
      @change="onArquivosAdicionar"
    />
    <input
      ref="inputSubstituir"
      type="file"
      :accept="substituirAccept"
      class="camadas-input-oculto"
      @change="onArquivoSubstituir"
    />

    <!-- Renomear -->
    <md-dialog :md-active.sync="renomearAberto" class="camadas-dialog-m3">
      <md-dialog-title>Renomear camada</md-dialog-title>
      <div class="camadas-dialog-conteudo">
        <md-field>
          <label>Nome</label>
          <md-input v-model="renomearNome" @keyup.enter="confirmarRenomear" />
        </md-field>
      </div>
      <md-dialog-actions>
        <md-button @click="renomearAberto = false">Cancelar</md-button>
        <md-button class="md-primary" @click="confirmarRenomear">
          Salvar
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- Editor de texto (nível 2.5) -->
    <md-dialog :md-active.sync="editorAberto" class="camadas-dialog-m3">
      <md-dialog-title>
        Editar {{ editorFormato }} — {{ editorNome }}
      </md-dialog-title>
      <div class="camadas-dialog-conteudo camadas-dialog-conteudo--largo">
        <p v-if="editorCarregando" class="camadas-editor-status">Carregando…</p>
        <div v-else class="camadas-editor">
          <label class="camadas-editor__label">
            Conteúdo {{ editorFormato }}
          </label>
          <codemirror
            v-model="editorTexto"
            class="camadas-editor__cm"
            :options="cmOptions"
          />
        </div>
      </div>
      <md-dialog-actions>
        <md-button @click="editorAberto = false">Cancelar</md-button>
        <md-button
          class="md-primary"
          :disabled="editorCarregando"
          @click="confirmarEditorTexto"
        >
          Salvar
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- Confirmar remoção -->
    <md-dialog-confirm
      class="camadas-dialog-m3 camadas-dialog-perigo"
      :md-active="camadaParaRemover !== null"
      md-title="Remover camada?"
      :md-content="mensagemRemover"
      md-confirm-text="Remover"
      md-cancel-text="Cancelar"
      @md-clicked-outside="camadaParaRemover = null"
      @md-cancel="camadaParaRemover = null"
      @md-confirm="confirmarRemover"
    />
  </div>
</template>

<script>
import 'codemirror/mode/xml/xml'
// autorefresh reajusta o tamanho quando o editor deixa de ficar oculto — o
// dialog do editor começa fechado, então sem isso o CodeMirror renderiza zerado.
import 'codemirror/addon/display/autorefresh'

import { codemirror } from 'vue-codemirror'

import juncao from '@/assets/map/icones/juncao.svg'
import tubulacao from '@/assets/map/icones/tubulacao.svg'
import auth from '@/utils/auth'
import { ORIGEM_EPANET_MODELO } from '@/utils/mapa-camadas'
import {
  chaveSoIcone,
  chaveUsaIcone,
  ICONE_POR_CHAVE,
} from '@/utils/mapa-icones'
import {
  COR_HUB,
  ICONE_HUB,
  iconeSensorDataUrl,
  TIPOS_ICONE_MAPA,
} from '@/utils/sensorMapaIcons'

const ICONE_GEOMETRIA_POR_CHAVE = {
  junctions: juncao,
  pipes: tubulacao,
}

export default {
  name: 'EquipamentoMapaCamadas',
  components: {
    codemirror,
  },
  props: {
    camadas: {
      type: Array,
      default: () => [],
    },
    // Alguma operação de camada em voo (carga inicial / adicionar / substituir):
    // mostra a faixa "Carregando…" e desabilita o botão de adicionar.
    carregando: {
      type: Boolean,
      default: false,
    },
    // Função que devolve o KML cru de uma camada: (id) => Promise<string>.
    // Mantém o acesso ao serviço na view-pai; o painel só consome sob demanda.
    carregarConteudo: {
      type: Function,
      required: true,
    },
    iconesSensorVisiveis: {
      type: Object,
      default: () => ({}),
    },
    equipamentosVisiveis: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      recolhido: false,
      equipamentosColapsado: false,
      sensoresColapsado: false,
      legendasSensor: {},
      legendaHub: '',
      colapsados: {},
      camadaParaRemover: null,

      renomearAberto: false,
      renomearId: null,
      renomearNome: '',

      editorAberto: false,
      editorId: null,
      editorNome: '',
      editorTipo: null,
      editorTexto: '',
      editorCarregando: false,

      substituirId: null,
      substituirAccept: '.kml',
    }
  },
  computed: {
    // Só quem tem MapaEdicao (ou Admin) vê as ações de escrita. Viewer ainda
    // pode alternar visibilidade localmente (não persiste — ver a view-pai).
    podeEditar() {
      return auth.canEditMapa()
    },
    tiposIconeMapa() {
      return TIPOS_ICONE_MAPA
    },
    algumSensorVisivel() {
      return TIPOS_ICONE_MAPA.some((tipo) => this.iconeSensorVisivel(tipo.id))
    },
    // Monta a lista em árvore para exibição, sem mutar a prop: itens de topo
    // (grupos INP e KMLs) ordenados por nome; sob cada grupo expandido vêm suas
    // filhas na ordem lógica de seção (links, depois nós). localeCompare pt-BR
    // trata acentos e caixa naturalmente.
    itensArvore() {
      const topo = this.camadas.filter((c) => c.tipo !== 'inp-secao')
      topo.sort((a, b) => {
        const ae = a.origem === ORIGEM_EPANET_MODELO ? 0 : 1
        const be = b.origem === ORIGEM_EPANET_MODELO ? 0 : 1
        if (ae !== be) return ae - be
        return a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' })
      })

      const itens = []
      topo.forEach((c) => {
        itens.push({ camada: c, nivel: 0 })
        if (c.tipo === 'grupo' && !this.colapsados[c.id]) {
          this.camadas
            .filter((f) => f.parentId === c.id)
            .forEach((f) => itens.push({ camada: f, nivel: 1 }))
        }
      })
      return itens
    },
    // Conta só os itens de topo (arquivos): um grupo INP conta como 1.
    totalTopo() {
      return this.camadas.filter((c) => c.tipo !== 'inp-secao').length
    },
    editorFormato() {
      return this.editorTipo === 'grupo' ? 'INP' : 'KML'
    },
    cmOptions() {
      return {
        // INP não é XML: modo texto puro evita destaque enganoso.
        mode: this.editorTipo === 'grupo' ? 'text/plain' : 'application/xml',
        lineNumbers: true,
        lineWrapping: true,
        tabSize: 2,
        autoRefresh: true,
      }
    },
    mensagemRemover() {
      const camada = this.camadaParaRemover
      if (!camada) return ''
      if (camada.tipo === 'grupo') {
        const n = this.camadas.filter((c) => c.parentId === camada.id).length
        return `O grupo "${camada.nome}" e suas ${n} camadas serão removidos do mapa.`
      }
      return `A camada "${camada.nome}" será removida do mapa.`
    },
  },
  async mounted() {
    if (document.fonts?.load) {
      await document.fonts.load('22px "Material Icons"')
    }

    const legendas = {}
    TIPOS_ICONE_MAPA.forEach((tipo) => {
      legendas[tipo.id] = iconeSensorDataUrl(tipo.id)
    })
    this.legendasSensor = legendas
    this.legendaHub = iconeSensorDataUrl(ICONE_HUB, { cor: COR_HUB })
  },
  methods: {
    iconeSensorVisivel(id) {
      return this.iconesSensorVisiveis[id] === true
    },
    lerArquivo(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(reader.error)
        reader.readAsText(file)
      })
    },

    // ----- Árvore (grupos INP) ----------------------------------------------
    alternarGrupo(id) {
      this.$set(this.colapsados, id, !this.colapsados[id])
    },
    grupoTemFilhaVisivel(grupo) {
      return this.camadas.some((c) => c.parentId === grupo.id && c.visivel)
    },
    // Há ajuste local (cor/visibilidade divergindo do default do banco)? No grupo
    // INP, reflete se alguma filha tem override. Controla o botão "Restaurar" e o
    // item "Salvar como padrão".
    temOverride(camada) {
      if (camada.tipo === 'grupo') {
        return this.camadas.some(
          (c) => c.parentId === camada.id && c.temOverride
        )
      }
      return !!camada.temOverride
    },
    // Tem ícone no mapa (válvula, reservatório) → legenda vira o próprio símbolo.
    usaIcone(camada) {
      return chaveUsaIcone(camada.chave)
    },
    // Tem geometria colorível (aresta/linha/nó): tudo menos grupo, seções "só
    // ícone" (reservatório) e as que usam escala de atributo (junções = Cota,
    // tubulações e válvulas = Diâmetro). Válvula mantém o ícone, mas a linha é
    // colorida pela escala de diâmetro — sem cor única.
    temCor(camada) {
      return (
        camada.tipo !== 'grupo' &&
        !chaveSoIcone(camada.chave) &&
        camada.chave !== 'junctions' &&
        camada.chave !== 'pipes' &&
        camada.chave !== 'valves'
      )
    },
    // URL do SVG da seção com ícone — usada como legenda na coluna da cor.
    iconeUrl(camada) {
      return ICONE_POR_CHAVE[camada.chave]
    },
    iconeGeometriaUrl(camada) {
      return ICONE_GEOMETRIA_POR_CHAVE[camada.chave] || ''
    },
    // Swatch de cor visível: só onde há cor E não há ícone (KML e seções INP
    // comuns). Válvula tem cor mas mostra o ícone — a cor vai pro clique/kebab.
    mostrarSwatch(camada) {
      return this.temCor(camada) && !this.usaIcone(camada)
    },
    // O kebab aparece se a linha tem ao menos um ITEM de menu para o usuário:
    // ações de arquivo (editor, exceto seção INP), "Alterar cor" (quando há
    // swatch) ou "Definir como padrão para todos" (editor com override). Restaurar
    // saiu do kebab — virou o ícone inline —, por isso override sozinho não conta.
    ehModeloEpanet(camada) {
      return camada?.origem === ORIGEM_EPANET_MODELO
    },
    podeEditarArquivo(camada) {
      return (
        this.podeEditar &&
        camada.tipo !== 'inp-secao' &&
        !this.ehModeloEpanet(camada)
      )
    },
    podeSalvarPadrao(camada) {
      return (
        this.podeEditar &&
        this.temOverride(camada) &&
        !this.ehModeloEpanet(camada)
      )
    },
    mostrarKebab(camada) {
      return (
        this.podeEditarArquivo(camada) ||
        this.temCor(camada) ||
        this.podeSalvarPadrao(camada)
      )
    },
    // Estado do olho: no grupo reflete se há alguma filha visível; na folha, ela
    // mesma.
    olhoVisivel(camada) {
      return camada.tipo === 'grupo'
        ? this.grupoTemFilhaVisivel(camada)
        : camada.visivel
    },
    rotuloErro(camada) {
      if (camada.tipo === 'grupo') return 'erro no INP'
      if (camada.tipo === 'kml') return 'erro no KML'
      return 'sem geometria'
    },

    // ----- Adicionar ---------------------------------------------------------
    acionarInputAdicionar() {
      this.$refs.inputAdicionar.click()
    },
    async onArquivosAdicionar(event) {
      const arquivos = Array.from(event.target.files)
      event.target.value = '' // permite reescolher o mesmo arquivo depois
      if (arquivos.length === 0) return

      const payload = await Promise.all(
        arquivos.map(async (file) => ({
          fileName: file.name,
          nome: file.name.replace(/\.(kml|inp)$/i, ''),
          conteudo: await this.lerArquivo(file),
        }))
      )
      this.$emit('adicionar', payload)
    },

    // ----- Substituir arquivo ------------------------------------------------
    acionarInputSubstituir(camada) {
      this.substituirId = camada.id
      this.substituirAccept = camada.tipo === 'grupo' ? '.inp' : '.kml'
      // nextTick: o :accept precisa ir ao DOM antes de abrir o seletor.
      this.$nextTick(() => this.$refs.inputSubstituir.click())
    },
    async onArquivoSubstituir(event) {
      const file = event.target.files[0]
      event.target.value = ''
      if (!file || !this.substituirId) return

      const conteudo = await this.lerArquivo(file)
      this.$emit('substituir', {
        id: this.substituirId,
        fileName: file.name,
        conteudo,
      })
      this.substituirId = null
    },

    // ----- Alterar cor -------------------------------------------------------
    // O item de menu apenas abre o seletor nativo do swatch da mesma linha
    // (mesmo caminho do clique direto no quadradinho — sem lógica duplicada).
    abrirSeletorCor(camada) {
      const input = this.$el.querySelector(`input[data-cor-id="${camada.id}"]`)
      if (input) input.click()
    },

    // ----- Renomear ----------------------------------------------------------
    abrirRenomear(camada) {
      this.renomearId = camada.id
      this.renomearNome = camada.nome
      this.renomearAberto = true
    },
    confirmarRenomear() {
      const nome = this.renomearNome.trim()
      if (!nome) return
      this.$emit('renomear', { id: this.renomearId, nome })
      this.renomearAberto = false
    },

    // ----- Editor de texto ---------------------------------------------------
    async abrirEditorTexto(camada) {
      this.editorId = camada.id
      this.editorNome = camada.nome
      this.editorTipo = camada.tipo
      this.editorTexto = ''
      this.editorCarregando = true
      this.editorAberto = true

      this.editorTexto = await this.carregarConteudo(camada.id)
      this.editorCarregando = false
    },
    confirmarEditorTexto() {
      this.$emit('substituir', {
        id: this.editorId,
        conteudo: this.editorTexto,
        // sem fileName: mantém o nome do arquivo original
      })
      this.editorAberto = false
    },

    // ----- Remover -----------------------------------------------------------
    confirmarRemover() {
      if (this.camadaParaRemover) {
        this.$emit('remover', this.camadaParaRemover.id)
      }
      this.camadaParaRemover = null
    },
  },
}
</script>

<style lang="scss" scoped>
.camadas-painel {
  position: absolute;
  // À direita do botão Voltar (left 12 + 44 de largura + 8 de folga = 64), na
  // mesma altura (top 12). max-width desconta os 64 da esquerda + 12 de margem.
  top: 12px;
  left: 64px;
  z-index: 5;
  width: 300px;
  max-width: calc(100% - 76px);
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  font-size: 14px;

  &__cabecalho {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    cursor: pointer;
    user-select: none;
  }

  &__titulo {
    flex: 1;
    font-weight: 600;
  }

  &__add {
    margin: 0;
    width: 28px;
    height: 28px;
    min-width: 28px;
  }

  &__chevron {
    margin: 0;
  }

  &__conteudo {
    border-top: 1px solid #eee;
  }

  &__corpo {
    max-height: 40vh;
    overflow-y: auto;
  }

  &__vazio {
    margin: 0;
    padding: 16px 12px;
    color: #757575;
  }

  &__carregando {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    color: #757575;

    ::v-deep .md-progress-spinner {
      flex: none;
    }
  }
}

.camadas-lista {
  list-style: none;
  margin: 0;
  padding: 0;
}

.camadas-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 4px 2px 10px;
  border-bottom: 1px solid #f2f2f2;

  &__olho {
    margin: 0;
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    min-width: 32px;
  }

  &__cor {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
    padding: 0;
    border: none;
    border-radius: 3px;
    background: none;
    cursor: pointer;
    // Affordance só no hover: em repouso parece uma legenda; ao passar o mouse
    // ganha anel + leve zoom, revelando que é clicável (proposta C).
    transition: transform 0.1s ease, box-shadow 0.1s ease;

    &::-webkit-color-swatch-wrapper {
      padding: 0;
    }

    &::-webkit-color-swatch {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }

    &::-moz-color-swatch {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }

    &:hover,
    &:focus-visible {
      transform: scale(1.2);
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.35);
      outline: none;
    }

    &--oculto {
      opacity: 0.3;
    }
  }

  &__info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  &__nome {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__erro {
    font-size: 11px;
    color: #c62828;
  }

  &__acoes {
    flex: 0 0 auto;

    .md-icon-button {
      margin: 0;
      width: 32px;
      height: 32px;
      min-width: 32px;
    }
  }

  // Flag/atalho de ajuste local: cor de destaque para ler como indicador (a
  // linha difere do padrão), não como só mais um botão neutro.
  &__restaurar {
    margin: 0;
    flex: 0 0 auto;
    width: 32px;
    height: 32px;
    min-width: 32px;

    ::v-deep .md-icon {
      font-size: 18px !important;
      color: #1565c0;
    }
  }

  // ----- Árvore (grupos INP) -----
  &__chevron {
    margin: 0;
    flex: 0 0 auto;
    // Quadrado (24×24) para o fundo redondo do md-icon-button não virar elipse,
    // mantendo a coluna do chevron estreita (alinha com __chevron-espaco).
    width: 24px;
    height: 24px;
    min-width: 24px;
  }

  // Reservam a coluna do chevron/swatch para alinhar olho e nome entre grupo,
  // KML e filha na mesma vertical.
  &__chevron-espaco {
    flex: 0 0 auto;
    width: 24px;
  }

  &__cor-espaco {
    flex: 0 0 auto;
    width: 16px;
  }

  // Seletor de cor da válvula: invisível mas RENDERIZADO (não display:none), pra
  // o .click() programático abrir o picker nativo de forma confiável e ancorá-lo
  // perto da linha. Quem dispara é o clique no ícone (ou o kebab); pointer-events
  // none evita que este input fantasma roube cliques.
  &__cor-gatilho {
    flex: 0 0 auto;
    width: 0;
    height: 0;
    padding: 0;
    border: 0;
    opacity: 0;
    pointer-events: none;
  }

  // Legenda de ícone (válvula/reservatório): ocupa a mesma coluna de 16px do
  // swatch, pra alinhar com as demais linhas. Escurece quando a camada some.
  &__legenda-icone {
    flex: 0 0 auto;
    display: block;
    width: 16px;
    height: 16px;
    object-fit: contain;

    &--oculto {
      opacity: 0.35;
    }

    // Válvula: a legenda também troca a cor da aresta — vira clicável, com o
    // mesmo "zoom no hover" do swatch pra revelar que é interativa.
    &--clicavel {
      cursor: pointer;
      transition: transform 0.1s ease;

      &:hover,
      &:focus-visible {
        transform: scale(1.2);
        outline: none;
      }
    }
  }

  &--grupo &__nome {
    font-weight: 600;
  }

  // Filha um degrau à direita do pai: a coluna do olho do grupo fica em 40px
  // (10 pad + 24 chevron + 6 gap); +16 de recuo deixa o olho da filha à direita
  // do olho do pai, dando a hierarquia visual de árvore.
  &--filha {
    padding-left: 56px;
    background: #fafafa;
  }

  // Neta (tipos de sensor): 56 da filha + 24 chevron + 16, para o olho ficar
  // à direita do olho de Sensores.
  &--neta {
    padding-left: 96px;
    background: #f5f5f5;
  }
}

.camadas-input-oculto {
  display: none;
}

.camadas-dialog-conteudo {
  padding: 0 24px;
  width: 420px;
  max-width: 90vw;

  // Editor de código pede largura generosa; min() mantém responsivo em telas
  // menores (limita a 92vw antes de chegar aos 1000px).
  &--largo {
    width: min(1000px, 92vw);
  }
}

.camadas-editor__label {
  display: block;
  margin-bottom: 6px;
  color: #757575;
  font-size: 13px;
}

.camadas-editor-status {
  padding: 16px 0;
  color: #757575;
}
</style>

<!--
  O .md-menu-content é teleportado para o <body>, fora do alcance do <style
  scoped>. A classe .camadas-menu restringe estes ajustes a este menu,
  alinhando-o à linguagem chapada e compacta dos demais controles do mapa
  (sombra rasa, raio 6px, linhas densas) em vez da elevação Material padrão.
-->
<style lang="scss">
.md-menu-content.camadas-menu {
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);

  .md-list {
    padding: 4px 0;
  }

  .md-list-item-content {
    min-height: 36px;
    padding: 6px 12px;
    font-size: 14px;
  }

  .md-list-item-content > .md-icon:first-child {
    margin-right: 12px;
  }

  .md-list-item-text {
    font-size: 14px;
  }
}
</style>

<!--
  O .CodeMirror é criado em runtime (sem atributo data-v) e o dialog é
  teleportado para o <body>, então o dimensionamento precisa vir de um bloco
  não-scoped. A classe wrapper .camadas-editor__cm mantém o alcance restrito.
-->
<style lang="scss">
@import '~codemirror/lib/codemirror.css';

.camadas-editor__cm .CodeMirror {
  // Altura definida (não `auto`): é o que mantém o scroll interno do CodeMirror
  // ativo. Com `auto` ele cresce sem barra e o conteúdo além do limite some.
  height: 55vh;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 12px;
}
</style>

<!--
  Restyle "M3-inspired" restrito aos diálogos desta rota (Renomear, Editor KML e
  o confirmar-remoção). O .md-dialog é teleportado para o <body>, fora do alcance
  do <style scoped>; a classe .camadas-dialog-m3 mantém estes ajustes isolados.
  Aproxima a FORMA/ELEVAÇÃO do Material 3 (canto 28px, sombra difusa, cabeçalho e
  ações mais limpos) sem trocar a lib — que é gen-1 e não suporta MD3 de verdade.

  Atenção: no vue-material o canto e a elevação ficam no .md-dialog-container
  (filho), não no .md-dialog (que é só o wrapper fixo de tela cheia). Por isso a
  forma/sombra são sobrescritas no container.
-->
<style lang="scss">
.md-dialog.camadas-dialog-m3 {
  .md-dialog-container {
    border-radius: 28px;
    // Elevação difusa e suave no lugar da sombra dura do Material clássico.
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 2px 6px rgba(0, 0, 0, 0.08);
    // O padrão do vue-material é max-width:80%; como o conteúdo do editor vai a
    // 92vw e o container tem overflow:hidden, em telas pequenas o editor era
    // cortado à direita. Casa o teto do cartão com o do conteúdo.
    max-width: 92vw;
  }

  .md-dialog-title {
    margin: 0;
    padding: 24px 24px 8px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.4;
  }

  .md-dialog-actions {
    padding: 8px 16px 16px;
    gap: 4px;

    // Ações M3 = text buttons: pílula, sem CAIXA ALTA. O .md-button já tem
    // overflow:hidden, então o raio recorta o ripple junto.
    .md-button {
      border-radius: 100px;
      padding: 0 16px;
      text-transform: none;
    }
  }
}

// Confirm de remoção: a ação principal é destrutiva. No M3 ela fica como text
// button na cor de erro (e não um botão vermelho preenchido). A classe extra
// .camadas-dialog-perigo isola isto ao confirm, sem tingir os "Salvar" dos
// outros diálogos, que também são .md-primary. #c62828 = mesmo vermelho de erro
// já usado neste componente (.camadas-item__erro).
.md-dialog.camadas-dialog-perigo .md-dialog-actions .md-button.md-primary {
  color: #c62828;
}
</style>
